var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_4476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 4.16659V1.66659C5.83268 1.44557 5.92048 1.23361 6.07676 1.07733C6.23304 0.921049 6.445 0.833252 6.66602 0.833252H13.3327C13.5537 0.833252 13.7657 0.921049 13.9219 1.07733C14.0782 1.23361 14.166 1.44557 14.166 1.66659V4.16659H17.4993C17.7204 4.16659 17.9323 4.25438 18.0886 4.41066C18.2449 4.56694 18.3327 4.7789 18.3327 4.99992V16.6666C18.3327 16.8876 18.2449 17.0996 18.0886 17.2558C17.9323 17.4121 17.7204 17.4999 17.4993 17.4999H2.49935C2.27834 17.4999 2.06637 17.4121 1.91009 17.2558C1.75381 17.0996 1.66602 16.8876 1.66602 16.6666V4.99992C1.66602 4.7789 1.75381 4.56694 1.91009 4.41066C2.06637 4.25438 2.27834 4.16659 2.49935 4.16659H5.83268ZM16.666 10.8333H3.33268V15.8333H16.666V10.8333ZM16.666 5.83325H3.33268V9.16658H5.83268V7.49992H7.49935V9.16658H12.4993V7.49992H14.166V9.16658H16.666V5.83325ZM7.49935 2.49992V4.16659H12.4993V2.49992H7.49935Z",
    fill: "#EEAC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_4476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcImg3);
export default __webpack_public_path__ + "static/media/arc-img-3.5c4f82e772fdc8c1b5155d9000a53733.svg";
export { ForwardRef as ReactComponent };